import { inject, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import { ShipmentApiUrlService } from '../services/shipment-api-url.service';

export const shipmentApiUrlInitProvider = provideAppInitializer(() => {
  const shipmentApiUrlService = inject(ShipmentApiUrlService);
  const router = inject(Router);

  shipmentApiUrlService.applyRuntimeConfiguration(router);
});
